import GraphAnalyticsComponent from "../../components/graph-analytics.component";
import TabToggleComponent from "../../components/tab-toggle.component";
import React from "react";
import {useSelector} from "react-redux";
import {formatDateToReadable} from "../../utils/general-variable";
import {useFetch} from "../../services/useFetch";
import {API} from "../../services/api";
import {useEffectAfterMount} from "../../services/useEffectAfterMount";
import {LoadingSvg} from "../../utils/image";

const TabVoucherOrdersGraph = () => {
    const {dateRange, reload} = useSelector(state => state.toolsReducer)
    const queryParams = {
        startDate: formatDateToReadable(dateRange[0], "YYYY-MM-DD"),
        endDate: formatDateToReadable(dateRange[1], "YYYY-MM-DD")
    }
    const {
        data: response,
        fetching: getVoucherOrdersGraph,
        isLoading
    } = useFetch(API.ANALYTIC_VOUCHER_ORDERS_GRAPH, queryParams)

    useEffectAfterMount(() => {
        getVoucherOrdersGraph()
    }, [dateRange, reload])

    return (
        <TabToggleComponent
            title={"Graphic Voucher Orders"}
            content={
                isLoading ? <img src={LoadingSvg} className={"w-12 mx-auto"}/> :
                    <GraphAnalyticsComponent title={'Total Order'} slug={'Order'}
                                             dataList={response?.data ?? []}/>
            }
        />
    )
}

export default TabVoucherOrdersGraph
